import React, { Fragment } from 'react';
import Push from './Push';
import { t } from 'translates';

function NoResult({ noResult }) {
  return (
    <div className="no-result">
      {noResult.message?.trim() && (
        <p className="no-result__desk">
          {noResult.message}
        </p>
      )}

      {noResult.pushes?.length > 0 && (
        <Fragment>
          <h3 className="no-result__title">{t('Suggestions', DT_SESSIONSNEW)}</h3>
          {noResult.pushes.map((item) => (
            item.id && (
              <div key={item.id} className="no-result__push">
                <Push {...item} />
              </div>
            )
          ))}
        </Fragment>
      )}
    </div>
  );
}

export default NoResult;
